import React, { Component, ComponentType } from 'react'
import { Box, ButtonProps, IconButton, Tooltip, TooltipProps } from '@mui/material'
import copy from 'clipboard-copy'
import DoneIcon from '@mui/icons-material/Done'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

export interface ICopyToClipboardProps {
  value: string
  slots?: {
    tooltipProps?: Partial<TooltipProps>
    button?: ComponentType<{ onClick: () => void; copied?: boolean }>
    buttonProps?: ButtonProps
  }
}

export interface ICopyToClipboardState {
  showTooltip: boolean
  copied: boolean
}

export class CopyToClipboard extends Component<ICopyToClipboardProps, ICopyToClipboardState> {
  constructor(props: ICopyToClipboardProps) {
    super(props)
    this.state = { showTooltip: false, copied: false }
  }

  render() {
    const leaveDelay = this.state.copied ? this.debounceTime.time - 200 : 0
    const { title, ...tooltipProps } = this.props.slots?.tooltipProps ?? {}
    const titleValue = this.state.copied ? 'Copied to clipboard!' : title ?? 'Copy to clipboard'
    return (
      <Tooltip
        arrow
        title={titleValue}
        leaveDelay={leaveDelay}
        open={this.state.showTooltip}
        onOpen={() => this.setState({ showTooltip: true })}
        onClose={() => this.setState({ showTooltip: false })}
        {...tooltipProps}
      >
        <Box sx={{ display: 'inline-block', flex: '0 0 auto' }}>{this.renderIcon()}</Box>
      </Tooltip>
    )
  }

  renderIcon = () => {
    if (this.props.slots?.button) {
      const ButtonComp = this.props.slots.button
      return <ButtonComp onClick={this.handleClickCopy} copied={this.state.copied} />
    }
    const Icon = this.state.copied ? DoneIcon : ContentCopyIcon
    return (
      <IconButton onClick={this.handleClickCopy} {...this.props.slots?.buttonProps}>
        <Icon fontSize='small' sx={{ color: '#606060' }} />
      </IconButton>
    )
  }

  handleClickCopy = () => {
    this.debounceTime.start()
    this.onCopy()
  }

  private debounceTime = {
    cache: 0 as any,
    time: 1500,
    start: () => {
      this.debounceTime.clear()
      this.setState({ copied: true }, () => {
        this.debounceTime.cache = setTimeout(() => {
          this.setState({ copied: false })
        }, this.debounceTime.time)
      })
    },
    clear: () => {
      clearTimeout(this.debounceTime.cache)
    }
  }

  private onCopy = () => {
    copy(this.props.value)
    this.setState({ showTooltip: true })
  }
}
export default CopyToClipboard
